import React from 'react'

import { ExternalFont } from './external-font'

export function Fonts() {
  return (
    <>
      <ExternalFont
        href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap"
        rel="stylesheet"
      />
      <ExternalFont
        href="https://use.typekit.net/uzh6xln.css"
        rel="stylesheet"
      />
      <ExternalFont
        href="https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap"
        rel="stylesheet"
      />
    </>
  )
}

// for @loadable/components
export default Fonts
